const Mutations = Object.freeze({
	SET_USERS: 'clientUserManagement/SET_DATA',
	SET_SELECTED_USER: 'clientUserManagement/SET_SELECTED_USER',
	SET_LOADING: 'clientUserManagement/SET_LOADING',
});
export const Actions = Object.freeze({
	LOAD_DATA: 'clientUserManagement/LOAD_DATA',
	LOAD_DATA_BYUSERID: 'clientUserManagement/LOAD_DATA_BYUSERID',
	INSERT: 'clientUserManagement/INSERT',
	UPDATE: 'clientUserManagement/UPDATE',
	DELETE: 'clientUserManagement/DELETE',
	CLEAR: 'clientUserManagement/CLEAR',
	CLEAR_SELECTED_USER: 'clientUserManagement/CLEAR_SELECTED_USER',
});
export const Getters = Object.freeze({
	GRID_LOADING: 'clientUserManagement/GRID_LOADING',
	GET_DATA: 'clientUserManagement/GET_DATA',
	GET_SELECTED_USER: 'clientUserManagement/GET_SELECTED_USER',
});
import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/clientUserManagementService';
import userProject from './userProject';
import userProjectPermission from './userProjectPermission';
export default {
	state: {
		loading: false,
		users: [],
		selectedUser: null,
	},
	modules: {
		userProject,
		userProjectPermission,
	},
	mutations: {
		[Mutations.SET_USERS](state, items) {
			state.users = items;
		},
		[Mutations.SET_SELECTED_USER](state, item) {
			state.selectedUser = item;
		},
		[Mutations.SET_LOADING](state, loading) {
			state.loading = loading;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_SELECTED_USER, null);
				commit(Mutations.SET_USERS, []);
				commit(Mutations.SET_LOADING, false);
				resolve();
			});
		},
		[Actions.CLEAR_SELECTED_USER]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_SELECTED_USER, null);
				resolve();
			});
		},
		[Actions.LOAD_DATA]({ commit, dispatch }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING, true);
				dataService
					.getAllUsers()
					.then((resp) => {
						commit(Mutations.SET_USERS, resp.data);
						commit(Mutations.SET_LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
		[Actions.LOAD_DATA_BYUSERID]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getByUserId(id)
					.then((resp) => {
						commit(Mutations.SET_SELECTED_USER, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.INSERT]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.insertUser(item)
					.then((resp) => {
						commit(Mutations.SET_SELECTED_USER, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.UPDATE]({ commit, dispatch }, user) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateUser(user)
					.then(() => {
						commit(Mutations.SET_SELECTED_USER, user.item);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.DELETE]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteUser(id)
					.then(() => {
						commit(Mutations.SET_SELECTED_USER, null);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
	},
	getters: {
		[Getters.GRID_LOADING]: (state) => {
			return state.loading;
		},
		[Getters.GET_DATA]: (state) => {
			if (state.users && state.users.length > 0) {
				return JSON.parse(
					JSON.stringify(
						state.users.sort((a, b) =>
							a.LastName > b.LastName ? 1 : -1
						)
					)
				);
			}
		},
		[Getters.GET_SELECTED_USER]: (state) => {
			if (state.selectedUser) {
				return JSON.parse(JSON.stringify(state.selectedUser));
			}
			return null;
		},
	},
};
